import { Select } from 'components/Select';

import { TProfessional } from 'types/appointment';

import s from './ServiceSelectors.module.css';

type TServiceSelectorsProps = {
  isMultiUser: boolean;
  serviceCategories: string[];
  selectedServiceCategory: string;
  selectServiceCategory: (selection: string) => void;
  selectedProfessional: TProfessional;
  onSelectProfessional: (selection: string) => void;
  professionals: TProfessional[];
};

export const ServiceSelectors = ({
  isMultiUser,
  serviceCategories,
  selectedServiceCategory,
  selectServiceCategory,
  selectedProfessional,
  onSelectProfessional,
  professionals,
}: TServiceSelectorsProps) => {
  const defaultCategory = { label: 'View All', value: 'View All' };
  const defaultProfessionalOption = {
    label: 'Any Professional',
    value: 'Any Professional',
  };

  const handleSelectProfessional = (selected: {
    value: string;
    label: string;
  }) => {
    onSelectProfessional(selected.value);
  };

  const profOptions = professionals.map((item) => ({
    value: item.guid,
    label: item.full_name,
  }));

  profOptions.unshift(defaultProfessionalOption);

  const serviceCategoryOptions = [
    defaultCategory,
    ...(serviceCategories
      ? serviceCategories.map((item) => ({
          label: item,
          value: item,
        }))
      : []),
  ];

  const selectedServiceCategoryOption =
    serviceCategoryOptions.find((o) => o.value === selectedServiceCategory) ||
    defaultCategory;

  const selectedProfessionalOption = !selectedProfessional
    ? defaultProfessionalOption
    : {
        value: selectedProfessional.guid,
        label: selectedProfessional.full_name,
      };

  return (
    <div className={s.container}>
      {isMultiUser && profOptions.length > 0 && (
        <Select
          id="professional-dropdown"
          name="professional"
          label="Select a Professional"
          options={profOptions}
          className={s.dropdownRoot}
          value={selectedProfessionalOption.value}
          onChange={handleSelectProfessional}
        />
      )}
      {serviceCategories?.length ? (
        <Select
          id="category-dropdown"
          name="category"
          label="Select a Category"
          options={serviceCategoryOptions}
          className={s.dropdownRoot}
          value={selectedServiceCategoryOption.value}
          onChange={(option: { value: string; label: string }) => {
            selectServiceCategory(option.value);
          }}
        />
      ) : null}
    </div>
  );
};
